import { render, staticRenderFns } from "./outdatedBrowser.vue?vue&type=template&id=640af8df&scoped=true&"
import script from "./outdatedBrowser.vue?vue&type=script&lang=js&"
export * from "./outdatedBrowser.vue?vue&type=script&lang=js&"
import style0 from "./outdatedBrowser.vue?vue&type=style&index=0&id=640af8df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640af8df",
  null
  
)

export default component.exports